import config from "../../config"
import RequestService from "../RequestService"

const updateTicket = (id, params, successCallback, failureCallback) => {
  RequestService.patch(`${config.backendUrl}/tickets/${id}`, { ticket: params }, successCallback, failureCallback)
}

export default updateTicket;